import Flickity from 'flickity';

export function overlay() {
    return {
        open: false,
        cells: [],
        index: 0,
        _flkty: null,

        init() {
            document.querySelectorAll('[data-gallery]').forEach(el => {
                this.cells.push({
                    src: el.getAttribute('data-gallery'),
                    caption: el.getAttribute('data-caption') || '',
                });
            });

            document.querySelectorAll('[data-trigger-zoom]').forEach(btn => {
                btn.addEventListener('click', e => {
                    e.preventDefault();
                    this.openAt(btn.getAttribute('data-trigger-zoom'));
                });
            });

            window.addEventListener('keydown', e => {
                if (e.key === 'Escape' && this.open) this.close();
            });
        },

        openAt(src) {
            this.open = true;
            this.$nextTick(() => {
                this._initFlickity();
                if (this._flkty) {
                    const i = this.cells.findIndex(c => c.src === src);
                    if (i >= 0) this._flkty.select(i, true, true);
                }
            });
        },

        _initFlickity() {
            if (this._flkty) return;
            const carousel = this.$refs.carousel;
            if (!carousel) return;

            this.cells.forEach(cell => {
                const div = document.createElement('div');
                div.className = 'overlay-slide absolute w-full h-full';
                const img = document.createElement('img');
                img.className = 'overlay-slide__img';
                img.src = cell.src;
                div.appendChild(img);
                carousel.appendChild(div);
            });

            this._flkty = new Flickity(carousel, {
                cellSelector: '.overlay-slide',
                fade: true,
                prevNextButtons: false,
                pageDots: false,
                adaptiveHeight: false,
                wrapAround: true,
                setGallerySize: false,
            });

            this._flkty.on('select', () => {
                this.index = this._flkty.selectedIndex;
            });
        },

        get caption() {
            return this.cells[this.index]?.caption || '';
        },

        close() {
            this.open = false;
        },

        next() {
            if (this._flkty) this._flkty.next();
        },

        prev() {
            if (this._flkty) this._flkty.previous();
        },
    };
}
